// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.search-answer-link[data-v-7074f9fb] {\r\n  display: block;\r\n  color: black;\n}\n.default-answer-link[data-v-7074f9fb] {\r\n  display: block;\r\n  color: black;\r\n  margin: 5px 0 5px 0;\n}\n.default-video-link[data-v-7074f9fb] {\r\n  color: black;\r\n  margin: 5px 0 5px 0;\n}\n.thumbpad[data-v-7074f9fb] {\r\n  margin: 10px;\r\n  padding: 10px;\r\n  text-align: left;\n}\n.thumb-border[data-v-7074f9fb] {\r\n  border: 1px solid black;\r\n  margin-bottom: 5px;\n}\r\n", ""]);
// Exports
module.exports = exports;
